import { Component, HostListener } from '@angular/core';
import { tap } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Toast } from 'src/app/shared/enums/toast';
import { HelpersService, HttpBaseService, ToastService } from '@evento-ng/libs';
import {
  championsApi,
  transferTicketApi,
} from 'src/app/shared/constants/api.constants';
import { IChampion } from 'src/app/shared/models/IChampion.model';
@Component({
  selector: 'app-transferred-tickets',
  templateUrl: './transferred-tickets.component.html',
  styleUrls: ['./transferred-tickets.component.scss'],
})
export class TransferredTicketsComponent {
  isMobileView = false;
  page: number;
  take: number;
  ticketsPage: number = 1;
  ticketsTake = 20;
  ticketsData: any;
  teamColor: any;
  selectAll = false;
  selectedTickets: any[];
  selectedTicketsIds: string[];
  tickets: any[];
  ticketsMeta: any;
  champions: IChampion;
  filterForm: FormGroup;

  constructor(
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    public helpers: HelpersService,
    private toast: ToastService,
    public translate: TranslateService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.checkIfMobile();
    this.getTransferredTicketsRequests();
    this.initform();
    this.getAllChampions();
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkIfMobile();
  }

  checkIfMobile() {
    const screenWidth = window.innerWidth;
    this.isMobileView = screenWidth <= 1024;
  }

  getTransferredTicketsRequests(): void {
    this.spinner.show();
    const params: any = {
      page: this.ticketsPage,
      take: this.ticketsTake,
    };
    const championId = this.filterForm?.value?.championId || null;
    if (championId) {
      params.championId = championId;
    }
    this.dataService
      .get(`${transferTicketApi}/my-requests`, { params: params })
      .pipe(
        tap(
          (res: any) => {
            this.tickets = res.data;
            this.ticketsMeta = res.meta;
            this.ticketsData = res;
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
          }
        )
      )
      .subscribe();
  }

  acceptTickets(): void {
    let ids = this.selectedTicketsIds;
    this.acceptTicket(ids);
  }

  acceptTicket(ids): void {
    this.spinner.show();
    this.dataService
      .post(`${transferTicketApi}/accept`, { ids: ids })
      .subscribe(
        (res) => {
          if (res.accepted == 0) {
            this.toast.show('Error', res.error, {
              classname: Toast.error,
            });
            this.spinner.hide();
          } else {
            this.toast.show(
              'Success',
              this.translate.instant('Sport.TicketAccepted'),
              {
                classname: Toast.success,
              }
            );
            this.spinner.hide();
            this.getTransferredTicketsRequests();
          }
        },
        (Err) => {
          this.spinner.hide();
        }
      );
  }

  goToPage(n: number): void {
    this.ticketsPage = n;
    this.getTransferredTicketsRequests();
  }

  onNext(): void {
    this.ticketsPage++;
    this.getTransferredTicketsRequests();
  }

  onPrev(): void {
    this.ticketsPage--;
    this.getTransferredTicketsRequests();
  }

  toggleSelectAll() {
    this.selectAll = !this.selectAll;
    this.tickets?.forEach((ticket) => (ticket.isChecked = this.selectAll));
    this.selectedTickets = this.tickets?.filter((ticket) => ticket.isChecked);
    this.selectedTicketsIds = this.selectedTickets?.map(
      (ticket) => ticket.transferOrderId
    );
  }

  toggleCheckbox(ticket: any) {
    ticket.isChecked = !ticket.isChecked;
    this.handleSelectedTickets();
  }

  handleSelectedTickets() {
    this.selectedTickets = this.tickets?.filter((ticket) => ticket.isChecked);
    if (this.selectedTickets?.length) {
      this.selectedTicketsIds = this.selectedTickets?.map(
        (ticket) => ticket.transferOrderId
      );
    } else {
      this.selectedTickets = null;
      this.selectedTicketsIds = null;
    }
  }

  onFilterChange() {
    this.getTransferredTicketsRequests();
  }

  private initform() {
    this.filterForm = this.formBuilder.group({
      championId: [''],
    });
  }

  getAllChampions() {
    this.spinner.show();
    this.dataService.get(`${championsApi}`).subscribe((res) => {
      this.champions = res.data;
      this.spinner.hide();
    });
  }
}
